import { ChangeDetectionStrategy, Component, HostListener, Input, OnChanges } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { DeviceService } from '@frontend/vanilla/core';

import { PopupManager } from '../../../../lib/popup/popup-manager.service';
import { notificationBubbleAnimation } from '../../../digital/services/notification-bubble-animation';
import { MultiReturnsMessageTrackingService } from '../multi-returns-message-tracking.service';

@Component({
    selector: 'bs-digital-multi-returns-message-popup',
    templateUrl: 'multi-returns-message-popup.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [notificationBubbleAnimation],
    styleUrls: ['./multi-returns-message-popup.component.scss'],
    standalone: false,
})
export class MultiReturnMessagePopupComponent implements OnChanges {
    @Input() message: string | null;
    @Input() animationState: 'top' | 'bottom';
    @Input() isShowAccaUpdatedInfo = false;

    isHighlighted: boolean;
    isiOS: boolean;
    topTransformValue: string;

    constructor(
        private popupManager: PopupManager,
        private trackingService: MultiReturnsMessageTrackingService,
        deviceService: DeviceService,
    ) {
        this.isiOS = deviceService.isiOS;
        if (deviceService.isMobile && !deviceService.isTablet) {
            this.topTransformValue = '0%';
        }
    }

    ngOnChanges(changes: ISimpleChanges<MultiReturnMessagePopupComponent>): void {
        this.isHighlighted = !changes.message?.firstChange;
    }

    @HostListener('click')
    onMessageClick(): void {
        this.trackingService.trackClick();
        this.popupManager.openBetslip();
    }
}
